import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import { dimensions } from "@styles";

import PatientBackground from "./PatientRxBackground.jpg";

export const background = (theme: Theme) => css`
  height: 100vh;
  background-image: url("${PatientBackground}");
  background-color: ${theme.system.backgroundMuted};
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: ${dimensions.desktopMax}) {
    background-position: 5% center;
  }
`;
